import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/gloable.css'
import request from "@/utils/request";


// 在 `request` 封装中，已经使用`axios.create()`创建了Axios实例，所以不媆要用request()创建；
Vue.prototype.request=request;   //注意这里的request是赋值，而不是调用；所以不要有()

Vue.config.productionTip = true;

Vue.use(ElementUI,{size:"mini"});  /*size让控件小点；*/

new Vue({
  router,
  store,  /*在vue中引用*/
  render: h => h(App)
}).$mount('#app')
